import { graphql } from '@shared/api/gql';

// Named `issuesList` (not `issues`) to stay distinct from queries.ts's
// `issuesQueryDocument` (operation `GetIssuesOptions`) -- this is a
// separate, simpler `Issues` operation, used via queries.ts's
// `issuesListOptions` factory by pages/issues/model/issues.hooks.ts (the
// `magazine` template's `/issues` list route).
export const issuesListQueryDocument = graphql(`
	query Issues {
		issues {
			id
			name
			description
			cover
			externalUrl
			price
			index
			slug
			currency
			data
			updated
			created
			releaseDate
			isPurchased
			isPaid
		}
	}
`);
